import { createElement } from 'rax';
import classNames from 'classnames';
import { getLogParamsString, setNavDotParams } from '../../common/dot';
interface Props {
  type: 'product' | 'supplier' | 'entrance' | 'nav' | 'custom';
  dotParams: Object;
  spmd: string | number;
  htmlType?: any;
  goldKeyObj?: {
    // 自定义黄金令箭key, 只针对type=custom有效且点击行为有效，如果不传会进行默认key的曝光和点击上报
    'clk'?: string;
  };
  className?: any;
  children?: any;
  [key: string]: any; // 对应htmlType的 标准dom属性

}
const typeArray = ['product', 'supplier', 'entrance', 'nav', 'custom'];
const helpStr = '文档：https://yuque.antfin-inc.com/ncms/oxxyex/kib0mw';
export default function Component(props: Props) {
  const {
    className,
    type,
    dotParams = {},
    spmd,
    children,
    htmlType,
    goldKeyObj,
    ...others
  } = props;
  let cls = classNames({
    [className]: className
  });
  const newspmd = (spmd || dotParams.spmd || '').toString().replace(/[^\d_a-zA-Z]/g, '');

  if (!type || typeArray.indexOf(type) === -1) {
    console.error && console.error(`DotElement的type属性设置错误， type=${type}`, helpStr);
  } // if (!dotParams.floorName && type !== 'nav') {
  //   console.warn && console.warn(`type=${type}的元素dotParams.floorName不能为空`, helpStr);
  // }
  // if (type === 'product' || type === 'supplier') {
  //   if (!dotParams.trackInfo) {
  //     console.warn && console.warn(`type=${type}的元素dotParams.trackInfo不能为空`, helpStr);
  //   }
  // } else if (type === 'nav') {
  //   if (!dotParams.navNames || dotParams.navNames.length == 0) {
  //     console.warn && console.warn(`type=${type}的元素dotParams.navNames不能为空`, helpStr);
  //   }
  //   // if (!dotParams.index && typeof dotParams.index !== 'number') {
  //   //   console.warn && console.warn(`type=${type}的元素dotParams.index不能为空`);
  //   // }
  // }


  let params = getLogParamsString(Object.assign({
    intelligent: 1
  }, dotParams));

  if (type === 'nav') {
    params = getLogParamsString(Object.assign({
      intelligent: 1
    }, setNavDotParams(dotParams)));
  }

  const WrapperTag = htmlType || 'div';
  return <WrapperTag {...others} className={cls} data-logtype={type} data-spm={newspmd ? newspmd : null} data-params={params}>
      {children}
    </WrapperTag>;
}